import React, { Component } from 'react'
import { Helmet } from 'react-helmet-async'
import Header from './header.jsx'
import Skills from './SkillSection.jsx'
import Employees from './Employees.jsx'
import './recruitHR.css'
class RecruitHR extends Component {

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        return (
            <React.Fragment>
                <div className="recruit-container">
                    <Helmet>
                        <title>チームについて | 日本アドバンストリーダーズソフトウェア株式会社</title>
                    </Helmet>
                    <Header />
                    <Skills />
                    <Employees />
                </div>
            </React.Fragment>
        )
    }
}

export default RecruitHR

